import React, { useEffect, useState } from "react";
import firstimg from "../../../img/step4.png";
import NavHear from "./NavHear";
import Footer from "./TestFooter/Footer";
import { Link, useNavigate } from "react-router-dom";
import "./heartest.css";
import { testQuestion } from "../../../Helper/Redux/API";
import { useDispatch } from "react-redux";
import loder from "../../../img/loder3.gif";

function Step4() {
  const history = useNavigate();
  const [selectedOption, setSelectedOption] = useState(
    JSON.parse(localStorage.getItem("step4"))?.answer_id
  ); // state to track selected option
  const [questionId, setQuestionId] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const handleRadioChange = (e) => {
    setSelectedOption(e);

    let step3Data = {
      question_id: questionId,
      answer_id: e,
    };
    localStorage.setItem("step4", JSON.stringify(step3Data));
    setTimeout(() => {
      history("/hearingtest/listening-situations/2");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 1000);
  };

  const [question, setQuestion] = useState("");
  const [answerOption, serAnswerOption] = useState([]);

  const dispatch = useDispatch();

  const getQuestion = () => {
    setIsLoading(true);
    const data = {
      page_number: 3,
    };
    try {
      dispatch(testQuestion(data)).then((res) => {
        if (res?.payload?.status === true) {
          setQuestion(res?.payload?.data[0]?.title);
          setQuestionId(res?.payload?.data[0]?.id);
          serAnswerOption(res?.payload?.data[0]?.options);
        }
        setIsLoading(false);
      });
    } catch (error) {
      console.log(error, "error");
      setIsLoading(true);
    }
  };

  useEffect(() => {
    getQuestion();
  }, []);

  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    // Check if there's a value in localStorage
    const localStorageValue = JSON.parse(localStorage.getItem("step4"));
    if (localStorageValue && localStorageValue.answer_id) {
      // Set showButton to true if there's a value
      setShowButton(true);
    } else {
      // Set showButton to false if there's no value
      setShowButton(false);
    }
  }, []);
  return (
    <>
      <div className="test-from">
        <NavHear />{" "}
        <section className="step_form">
          <div className="container">
            {/* container start */}
            <section className="step_1 step2  wow  fadeInUp animated">
              <div className="row">
                <div className="col-md-6">
                  <div className="step1_img">
                    <div className="step2_button">
                      <Link to="/hearingtest/intro">
                        <button className="btn">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="9"
                            height="14"
                            viewBox="0 0 9 14"
                            fill="none"
                          >
                            <path
                              d="M1.01766 6.19021L6.34381 1.00499C6.79725 0.563551 7.5289 0.563552 7.98234 1.00499C8.44067 1.4512 8.44067 2.17836 7.98234 2.62456L3.48798 7L7.98234 11.3754C8.44067 11.8216 8.44067 12.5488 7.98234 12.995C7.5289 13.4364 6.79726 13.4364 6.34382 12.995L1.01766 7.80979C0.559328 7.36358 0.559328 6.63642 1.01766 6.19021Z"
                              fill="white"
                              stroke="white"
                              stroke-width="0.652176"
                            />
                          </svg>
                          <span>3/6</span>
                        </button>
                      </Link>
                    </div>
                    <img src={firstimg} className="img-fluid" alt="first-img" />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="step1_text">
                    <h1>About you</h1>
                    <p className="new_space">{question}</p>
                    <div className="step2_seletct step4_seletct">
                      <h5>Select your option</h5>

                      {isLoading ? (
                        <div>
                          <img src={loder} alt="loder" className="lodedr_img" />
                        </div>
                      ) : (
                        <ul className="list_item">
                          {answerOption?.map((option, i) => (
                            <li key={i}>
                              <div
                                className={`form-check form-check-inline ${
                                  selectedOption == option?.id ? "checked" : ""
                                }`}
                              >
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="inlineRadioOptions"
                                  id="inlineRadio1"
                                  value={option?.id}
                                  checked={selectedOption == option?.id}
                                  onChange={(e) =>
                                    handleRadioChange(e.target.value)
                                  }
                                />
                                <span className="raound_text"></span>
                                <label
                                  className="form-check-label"
                                  for="inlineRadio1"
                                >
                                  {option?.title}
                                </label>
                              </div>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {showButton && (
                <Link to="/hearingtest/listening-situations/2">
                  <button className="next_btn">Next</button>
                </Link>
              )}
            </section>
            {/* container end */}
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
}

export default Step4;
